import React, { useState } from 'react';
import { useData } from '../DataHook';
import { Button, ButtonGroup } from 'react-bootstrap';
import CustomAddModal from './CustomAddModal';

export default function ({ name, unit, color, bag, box }) {
  const { addCount, counts } = useData();
  const [showCustomModal, setShowCustomModal] = useState(false);
  const [selectedUnit, setSelectedUnit] = useState(2);

  return <>
    <div style={{ borderColor: color }} className="item container">
      <h2>{name}</h2>
      <div className="f-flex mb-2">
        <div className="d-flex flex-column">
          <ButtonGroup aria-label={"Add" + name}>
            <Button variant="success" onClick={() => { addCount(name, bag * box); setSelectedUnit(1); }}>Box</Button>
            <Button variant="success" onClick={() => { addCount(name, bag); setSelectedUnit(0); }}>Bag</Button>
            <Button variant="success" onClick={() => { setShowCustomModal(true); }}>Custom</Button>
          </ButtonGroup>
        </div>
      </div>
      <h3>Total: <span>{counts[name] || 0} {unit[1]}</span></h3>
    </div>
    <CustomAddModal
      show={showCustomModal}
      onHide={() => setShowCustomModal(false)}
      itemName={name}
      unit={unit}
      bag={bag}
      box={box}
      selectedUnit={selectedUnit}
      setSelectedUnit={setSelectedUnit} />
  </>;
}